import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BaiduMap from'vue-baidu-map'
import '../src/assets/stylus/index.stylus'
import { Carousel,CarouselItem } from 'element-ui';
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 };
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(BaiduMap,{ak:'GGG3US0cGrBqBXAziC5hLCaMN40cGYft'})
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
